import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { StatusMismatchPage } from '@/features/monitoring'

const statusMismatchSearchSchema = z.object({
  tab: z
    .union([
      z.literal('active_offline'),
      z.literal('active_los'),
      z.literal('suspended_online'),
    ])
    .optional()
    .catch('active_los'),
  olt: z.string().optional().catch('ALL'),
  q: z.string().optional().catch(''),
  page: z.number().optional().catch(1),
  // Admin-only switch (see [[not_notified feature]] in apidatanet) - ignored
  // server-side for non-admins regardless of what's in the URL, so there's
  // nothing to gate here at the schema level too.
  notNotified: z.boolean().optional().catch(false),
})

export const Route = createFileRoute(
  '/_authenticated/monitoring/status-mismatch'
)({
  validateSearch: statusMismatchSearchSchema,
  component: () => (
    <RequirePermission permission='monitoring.read'>
      <StatusMismatchPage />
    </RequirePermission>
  ),
})
